import type { AxiosInstance } from 'axios';

import SystemUserApi from './systemUser.api';
import LoginApi from './login.api';
import MenuApi from './menu.api';
import PermissionApi from './permission.api';
import MemberApi from './member.api';
import MemberListApi from './memberList.api';
import RecordApi from './record.api';

export type ApiContext = ReturnType<typeof createAdminApi>;

export function createAdminApi(api: AxiosInstance) {
  return {
    SystemUser: SystemUserApi(api),
    Login: LoginApi(api),
    Menu: MenuApi(api),
    Permission: PermissionApi(api),
    Member: MemberApi(api),
    MemberList: MemberListApi(api),
    Record: RecordApi(api)
  };
}